import Image, { type StaticImageData } from "next/image";
import styles from "./ResponsiveImage.module.scss";

interface ImageProps {
  src: string | StaticImageData;
  alt: string;
  sizes?: string;
  className?: string;
  ignoreRounded?: boolean;
  roundedBorder?: number | string;
  containerClassNames?: any;
  containerStyles?: any;
  styles?: any;
  onMouseOver?: any;
  onMouseOut?: any;
}

export default function ResponsiveImage(props: ImageProps) {
  let classNames = styles.image;
  if (props.className) {
    classNames += " " + props.className;
  }

  const style = {}
  if (!props.ignoreRounded) {
    style["borderRadius"] = props.roundedBorder === undefined ? 10 : props.roundedBorder;
  }

  return (
    <div
      className={`${styles.imageContainer} ${props.containerClassNames}`}
      style={{
        ...style,
        ...(props.containerStyles || {}),
      }}
    >
      <Image
        className={classNames}
        alt={props.alt}
        src={props.src}
        layout="fill"
        sizes={props.sizes}
        style={{
          ...(props.ignoreRounded
            ? {}
            : {
              borderRadius:
                props.roundedBorder === undefined ? 10 : props.roundedBorder,
            }),
          ...(styles || {}),
          ...(props.styles || {}),
        }}
      />
    </div>
  );
}
